import * as React from 'react';
import { Form } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
const OverriddenCheckoutForm = props => {
    return React.createElement(Form, Object.assign({}, props, { showCheckDataModal: true }));
};
export default OverriddenCheckoutForm;
